/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function MenuIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "menu", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5 7.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5 17.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5 12.5H20", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(MenuIcon);
export default ForwardRef;
//# sourceMappingURL=menuIcon.js.map